<template>
    <div class="container">
        <p class="contentBlack">欢迎您使用“{{ this.name }}”软件及相关服务，“{{ this.name }}”由{{ this.company }}技术团队开发，根据以下服务条款为您提供服务。</p>
        <p class="contentBlack">在您(用户)注册及/或开始使用“{{ this.name }}“软件及相关服务前，特别提醒您认真阅读并充分理解本《用户协议》(以下简称“本协议”) ， 
            确保您充分理解本协议中各条款。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款(该等条款通常含有“不负任何责任”、“无义务”等词汇)，
            和其他限制用户权利的条款(该等条款通常含有“不得”等词汇)，限制、免责条款可能以加粗形式提示您注意。除非您完全接受本协议所有条款，否则您无权注册、
            登录或使用本协议所涉服务。您的注册、登录、使用等行为将视为您对本协议内容的接受，也视为您同意接受本协议各项条款的约束。如您对本协议内容有任何疑问、
            意见或建议，您可通过“{{ this.name }}”客户端内的“帮助与咨询”页面与我们联系。</p>

        <p class="contentBlack">用户在申请注册账号之日应为年满18周岁的自然人，本公司将依赖用户提供的个人信息判断用户是否为未成年人，
            如您未满18周岁，您不得注册、登录“{{ this.name }}”或使用本服务。如果您年满18周岁但存在其他不具备与您行为相适应的民事行为能力的情形，
            请在监护人的陪同下阅读本协议。请确保您的监护人同意您的所有行为，在此情况下，您及您的监护人应依照法律规定承担因此而导致的一切后果。</p>

        <p class="contentBlack">1.适用范围</p>
        <p class="content">1.1本协议就您注册、登陆、使用“{{ this.name }}”软件，并获得“{{ this.name }}”软件提供的相关服务(以下简称“服务”)所订立的协议。
            {{ this.company }}（以下简称“公司”）有权依“{{ this.name }}”软件及相关服务或运营的需要单方决定、安排或指定其关联公司、控制公司、
            继承公司或公司认可的第三方公司继续运营“{{ this.name }}”软件，并向您提供部分/全部服务。您理解并同意接受相关服务内容，
            即视为接受相关权利义务关系亦受本协议约束。</p>
        <p class="content">
            1.2“用户”是指直接或间接获取和使用“{{ this.name }}”软件及相关服务的使用者，包括免费用户及付费用户，本协议中称为“用户”或“您”。
            “{{ this.name }}”是指由公司合法拥有并运营的、标注为“{{ this.name }}”的客户端应用程序以及域名网站。公司有权对应用程序及网站名称等单方予以变更(包括但不限于更名、新增等)。
        </p>
        <p class="content">
            1.3考虑到互联网服务不断高速发展和演进，本协议及相关服务协议、规则等可由公司进行更新，更新后，公司将提前在相关页面公布更新后的内容，您同意承担及时阅读、
            提出意见和确认更新后的内容的义务。如您不同意更新后的内容，请立即停止访问和使用“{{ this.name }}”软件并取消已获得的服务；如果您选择在更新后继续使用“{{ this.name }}”软件，
            则视为您已接受更新后的内容。
        </p>


        <p class="contentBlack">2.帐号相关</p>
        <p class="content">
            2.1您在使用本协议相关服务前需要注册“{{ this.name }}”帐号，该帐号提交的所有注册信息必须真实准确，请您使用尚未与“{{ this.name }}”帐号绑定的且未被“{{ this.name }}”根据本协议封禁的手机号码，
            或微信、QQ等第三方账号。公司可以根据用户需求或产品需要对帐号注册和绑定的方式进行变更，而无须事先通知您。
        </p>
        <p class="content">
            2.2“{{ this.name }}”系基于地理位置的移动社交产品，用户注册时应当授权“{{ this.name }}”公开及使用您的IP地址信息方可成功注册“{{ this.name }}”帐号。
            您知晓并同意您完成“{{ this.name }}”账号注册即表明您同意“{{ this.name }}”为履行本协议提取、公开及使用您的IP地址信息。
        </p>
        <p class="content">
            2.3您理解并承诺您所设置的账号内容(包括但不限于账号名称、头像、内心独白等)满足下列要求：不得违反国家法律法规及公司的相关规则，
            不得使用他人名义注册“{{ this.name }}”账号，不得恶意注册“{{ this.name }}”账号(包括但不限于频繁注册、批量注册等)，禁止使用包括虚拟机、
            群控软件或硬件等方式虛假注册和使用账号。对于使用多个账号进行恶意注册，{{ this.name }}有权永久冻结其账号。您在“{{ this.name }}”账号注册及/或使用过程中，
            不得实施任何侵害国家利益、损害他人合法权益、有害社会道德风尚的行为。公司有权对您提交的注册信息进行审核，但上述审核并不免除您的相关法律责任。
        </p>
        <p class="content">
            2.4.鉴于“{{ this.name }}”帐号的绑定注册方式，您同意“{{ this.name }}”在您注册“{{ this.name }}”账号时使用您提供的手机号码或自动提取您的手机号码及自动提取您的手机设备识别码等信息用于注册。
            您同意给予运营商授权，授权运营商有权自动提取您的手机号码进行认证并用于“{{ this.name }}”账号注册，您保证遵守运营商的相关服务条款，如运营商对您的手机号码认证成功，
            则您的账号注册即完成。如您不同意对运营商的授权和或服务条款或者是您的手机号认证失败，您可以手动修改运营商提取的手机号码，采取验证码方式进行注册登录。
        </p>
        <p class="content">
            2.5在您注册、使用及管理账号时，您保证注册账号时填写及使用的信息的真实性、合法性及有效性，包括但不限于您的姓名、联系电话、地址等。
            依照国家法律法规的规定，为使用“{{ this.name }}”软件及相关服务，您需要填写真实的身份信息及或完成实名认证，并注意及时更新上述相关信息。
            否则公司有权拒绝为您提供相关服务或您可能无法使用“{{ this.name }}”软件及相关服务或在使用过程中部分功能受限。
        </p>
        <p class="content">
            2.6“{{ this.name }}”帐号的所有权归公司所有，您完成申请注册手续后，获得“{{ this.name }}”帐号的使用权，该使用权仅属于您(初始申请注册人)，
            禁止以任何形式赠与、借用、租用、转让、售卖(如果出现纠纷或者法律问题，原账号所有者需在法律框架内承担法律责任)或以其他方式许可他人使用账号。
            如果公司发现或者有合理理由认为使用者并非您(初始申请注册人)，或因经营需要，公司有权立即暂停或终止向您提供服务，或注销您的账号；
            以及公司有权视您账号使用过程中的违规程度做出清除提现货币或是永久冻结操作。
        </p>
        <p class="content">
            2.7您可以通过“我的”页面里“基本资料”页对您的个人信息进行修改，但需注意，在您删除有关信息的同时也会删除您储存在系统中的文字和图片，对此您需承担相应的风险。
        </p>
        <p class="content">
            2.8您有责任妥善保管注册帐号信息及帐号密码，如因您保管不善导致被盗号或密码失窃,责任将由您自行承担。您需对使用注册帐号所从事的全部活动承担法律责任，
            包括但不限于您在“{{ this.name }}”上进行的任何数据修改、言论发表、款项支付等操作行为。如果您未保管好自己的帐号和密码而对您、“{{ this.name }}”或第三方造成的损害，您将负全部责任。
        </p>
        <p class="content">
            2.9您应遵守本协议的各项条款，正确、适当地使用本协议相关服务，如您违反本协议及平台其他规则中的任何条款，
            “{{ this.name }}”将在通知您后依据法律法规及本协议规定中断或终止对您的服务。
        </p>
        <p class="content">
            2.10您可以通过“我的“--“系统设置”--“账户安全”进行账号注销，在您进行账号注销后，公司将根据适用法律法规的要求尽快删除相关的信息和数据，
            故您在注销前应自行备份与“{{ this.name }}”账号相关的信息和数据，且您知晓并确认账号注销完成后即不可恢复（特别提示：后续如果进行举报或其他任何投诉行为，
            注销后平台是没有任何记录可以查询的，若用户自己无法提供充分证据证明被投诉行为，平台将无法处理）。
            您确认并同意注销账号后并不代表你对你的“{{ this.name }}”账号注销前的使用行为和相关责任得到豁免或减轻，如在注销期间，您的账号被他人投诉、
            被国家机关调查或者正处于诉讼、仲裁程序中，公司有权自行终止您的账号注销并无需另行得到您的同意。
        </p>
        <p class="content">
            2.11为提高您的曝光率，公司可能会将您使用“{{ this.name }}”账号所发布的全部内容自动同步发布至公司及或关联公司运营的系列客户端软件及网站，
            您在“{{ this.name }}”发布、 修改、删除内容的操作可能会同步到上述系列客户端软件及网站。如您通过已注册或者已同步的账号登录公司及或关联公司运营的系列客户端软件及网站(如有)，
            您应遵守该软件及网站自身的《用户协议》及其他协议条款的规定。
        </p>
        <p class="content">
            2.12根据有关法律法规，“{{ this.name }}”在此郑重提醒您注意，任何经由本服务而发布、上传的文字、照片、或其它资料（以下简称“内容”），
            无论系公开还是私下传送，均由内容提供者承担责任。“{{ this.name }}”仅为用户提供内容存储空间，无法控制经由本服务传送之内容，因此不保证内容的正确性、完整性或品质。
            您已预知使用本服务时，可能会接触到令人不快、不适当或令人厌恶之内容。在任何情况下，“{{ this.name }}”均不为任何内容负责，
            但“{{ this.name }}”有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用本服务的全部或部分，保存有关记录，并向有关机关报告。
        </p>


        <p class="contentBlack">3.服务内容</p>
        <p class="content">
            3.1本服务的具体内容由公司根据实际情况提供，包括但不限于授权您通过您的帐号进行即时通讯、添加好友、加入家族、加入群组、关注他人、发布留言等。
            为了更好的提升您的体验及服务,公司将不定期的进行软件的更新或改变,包括但不限于软件的升级、修改、功能强化等。软件更新后，
            您将会收到“{{ this.name }}”关于服务变更的通知，您有权选择接受或者不接受更新版本或服务，如您不接受，你确认知晓部分功能将可能受到限制或不能继续使用。
        </p>
        <p class="content">
            3.2“{{ this.name }}”提供的服务包含免费服务与收费服务。用户可以通过付费方式购买收费服务，具体方式为：用户通过支付宝或微信，
            苹果支付及其他“{{ this.name }}”平台提供的支付工具支付一定数额的人民币用于购买会员服务或金币，用户不可撤销地同意将充值到账的金币由平台代为保管，
            并不可撤销地授权平台根据“{{ this.name }}”公布的资费标准以金币购买用户欲使用的收费服务，从而获得收费服务使用权限；用户通过花费金币兑换礼物，文字，
            音频，视频等服务给其他指定用户，用户知晓接收方可以转换成现金并可提现。对于收费行为， “{{ this.name }}”会在用户使用之前给予用户明确的提示，
            只有用户根据提示确认其同意按照前述支付方式支付费用并完成了支付行为，用户才能使用该等收费服务。支付行为的完成以第三方支付平台生成“支付已完成”的确认通知为准。
            只要用户经付费提示继续进行操作，即表示用户同意该收费标准。用户在购买收费服务时，应仔细核对账号名称、开通服务类型与时长等具体信息，
            如因用户原因造成充错账号、开通错服务类型或时长等纠纷的，公司不予退还已收取的费用。
        </p>


        <p class="contentBlack">4.用户个人信息保护</p>
        <p class="content">4.1用户在注册帐号或使用本服务的过程中，可能需要填写或提交-些必要的个人信息，如法律法规、规章规范性文件(以下称“法律法规”)规定的需要填写的身份信息。
            如用户提交的信息不完整或不符合法律法规的规定，则用户可能无法使用本服务或在使用本服务的过程中受到限制。</p>
        <p class="content">4.2用户个人信息包括: 1) 用户自行提供的用户个人信息(如注册时填写的手机号码，电子邮件等个人信息，使用服务时提供的共享信息等) ;
             2)其他方分享的用户个人信息;3)公司为提供服务而合法收集的用户必要个人信息(如使用服务时系统自动采集的设备或软件信息，浏览历史信息，通讯时间信息等技术信息，
             用户开启定位功能并使用服务时的地理位置信息等)。</p>
        <p class="content">4.3尊重和保护用户个人信息是公司的一贯制度，公司将采取技术措施和其他必要措施，确保用户个人信息安全，防止在本服务中收集的用户个人信息泄露、
            毁损或丢失。在发生前述情形或者公司发现存在发生前述情形的可能时，公司将及时采取补救措施并告知用户,用户如发现存在前述情形亦需立即与公司联系。</p>
        <p class="content">
            4.4公司未经用户同意不向任何第三方公开、透露用户个人信息。但以下特定情形除外:
        </p>
        <p class="content">
            (1)公司根据法律法规规定或有权机关的指示提供用户的个人信息;
        </p>
        <p class="content">
            (2)由于用户将其用户密码告知他人或与他人共享注册帐户与密码，由此导致的任何个人信息的泄漏，或其他非因公司原因导致的个人信息的泄露;
        </p>
        <p class="content">
            (3)用户自行向第三方公开其个人隐私信息;
        </p>
        <p class="content">
            (4)用户与公司及合作单位之间就用户个人隐私信息的使用公开达成约定，公司因此向合作单位公开用户个人隐私信息;
        </p>
        <p class="content">
            (5)任何由于黑客攻击、电脑病毒侵入及其他不可抗力事件导致用户个人隐私信息的泄露;
        </p>
        <p class="content">
            (6)用户个人信息已经经过处理无法识别特定个人且不能复原。
        </p>
        <p class="content">
            4.5用户同意公司可在以下事项中使用用户的个人信息:
        </p>
        <p class="content">
            (1)公司向用户及时发送重要通知，如软件更新、本协议条款的变更;
        </p>
        <p class="content">
            (2)公司内部进行审计、数据分析和研究等，以改进公司的产品、服务和与用户之间的沟通;
        </p>
        <p class="content">
            (3)依本协议约定，公司管理、审查用户信息及进行处理措施;
        </p>
        <p class="content">
            (4)适用法律法规规定的其他事项。
        </p>
        <p class="contentBlack">
            除上述事项外，如未取得用户事先同意，公司不会将用户个人隐私信息使用于任何其他用途。
        </p>
        <p class="content">
            4.6公司重视对未成年人的保护。公司将依赖用户提供的个人信息判断用户是否为未成年人。任何18岁以下的未成年人均不得注册帐号或使用本服务。
        </p>
        <p class="content">
            4.7公司保证在合法、正当与必要的原则下收集、使用或者公开用户个人信息且不会收集与提供的服务无关的用户个人信息。
        </p>


        <p class="contentBlack">5.内容规范</p>
        <p class="content">
            5.1本条所述内容是指用户使用本服务过程中所制作、上载、复制、发布、传播的任何内容，包括但不限于帐号头像、名称、用户说明等注册信息及认证资料，
            或文字、语音、图片、视频、图文等发送、回复或自动回复消息和相关链接页面，以及其他使用帐号或本服务所产生的内容。
        </p>
        <p class="content">
            5.2用户在使用本服务过程中所制作、上载、复制、发布、传播的内容应遵守法律法规、遵循公序良俗，不得损害国家利益、公共利益和他人合法权益，
            内容应弘扬社会主义核心价值观。公司有权根据本协议的禁止性规定以及视您账号使用过程中的违规程度做出清除提现货币或是永久冻结操作。
        </p>
        <p class="content">
            (1)反对宪法所确定的基本原则的;
        </p>
        <p class="content">
            (2)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的;
        </p>
        <p class="content">
            (3)损害国家荣誉和利益的;
        </p>
        <p class="content">
            (4)煽动民族仇恨、民族歧视，破坏民族团结的;
        </p>
        <p class="content">
            (5)破坏国家宗教政策，宣扬邪教和封建迷信的;
        </p>
        <p class="content">
            (6)散布谣言，扰乱社会秩序，破坏社会稳定的;
        </p>
        <p class="content">
            (7)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的;
        </p>
        <p class="content">
            (8)侮辱或者诽谤他人，侵害他人合法权益的;
        </p>
        <p class="content">
            (9)不遵守法律法规底线、社会主义制度底线、国家利益底线、公民合法权益底线、社会公共秩序底线、
            道德风尚底线和信息真实性底线的“七条底线”要求的;
        </p>
        <p class="content">
            (10)含有法律、行政法规禁止的其他内容的信息。
        </p>
        <p class="content">
            5.3用户不得利用“{{ this.name }}”帐号或本服务制作、上载、复制、发布、传播如下法律、法规和政策禁止的内容:
        </p>
        <p class="content">
            (1)反对宪法所确定的基本原则的;
        </p>
        <p class="content">
            (2)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的;
        </p>
        <p class="content">
            (3)损害国家荣誉和利益的;
        </p>
        <p class="content">
            (4)煽动民族仇恨、民族歧视，破坏民族团结的;
        </p>
        <p class="content">
            (5)破坏国家宗教政策，宣扬邪教和封建迷信的;
        </p>
        <p class="content">
            (6)散布谣言，扰乱社会秩序，破坏社会稳定的;
        </p>
        <p class="content">
            (7)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的;
        </p>
        <p class="content">
            (8)侮辱或者诽谤他人，侵害他人合法权益的;
        </p>
        <p class="content">
            (9)不遵守法律法规底线、社会主义制度底线、国家利益底线、公民合法权益底线、社会公共秩序底线、
            道德风尚底线和信息真实性底线的“七条底线”要求的;
        </p>
        <p class="content">
            (10)含有法律、行政法规禁止的其他内容的信息。
        </p>
        <p class="content">
            5.4用户不得利用“{{ this.name }}”帐号或本服务制作、上载、复制、发布、传播如下干扰“{{ this.name }}”正常运营，
            以及侵犯其他用户或第三方合法权益的内容:
        </p>
        <p class="content">
            (1)含有任何性或性暗示的;
        </p>
        <p class="content">
            (2)含有辱骂、恐吓、威胁内容的;
        </p>
        <p class="content">
            (3)含有骚扰、垃圾广告、恶意信息、诱骗信息的;
        </p>
        <p class="content">
            (4)涉及他人隐私、个人信息或资料的;
        </p>
        <p class="content">
            (5)侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的;
        </p>
        <p class="content">
            (6)含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息。
        </p>
        <p class="content">
            5.5如您使用“{{ this.name }}”的通讯服务(包括语音和视频)，公司有权对您的通讯(包括语音和视频)内容进行实时审核，
            通讯内容违反国家法律及本协议相关规定，公司有权视情节轻重采取警示、暂停通讯、清除提现货币或永久冻结账号、
            配合主管部门调查等处置措施。
        </p>

        <p class="contentBlack">6.使用规则</p>
        <p class="content">
            6.1用户在本服务中或通过本服务所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表公司的观点、
            立场或政策，公司对此不承担任何责任。
        </p>
        <p class="content">
            6.2用户不得利用“{{ this.name }}”帐号或本服务进行如下行为:
        </p>
        <p class="content">
            (1)提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义的;
        </p>
        <p class="content">
            (2)强制、诱导其他用户关注、点击链接页面或分享信息的;
        </p>
        <p class="content">
            (3)虚构事实、隐瞒真相以误导、欺骗他人的;
        </p>
        <p class="content">
            (4)利用技术手段批量建立虚假帐号的;
        </p>
        <p class="content">
            (5)利用“{{ this.name }}”帐号或本服务从事任何违法犯罪活动的;
        </p>
        <p class="content">
            (6)制作、发布与以上行为相关的方法、工具，或对此类方法、工具进行运营或传播，无论这些行为是否为商业目的;
        </p>
        <p class="content">
            (7)其他违反法律法规规定、侵犯其他用户合法权益、干扰“{{ this.name }}”正常运营或公司未明示授权的行为。
        </p>
        <p class="content">
            6.3用户须对利用“{{ this.name }}”帐号或本服务传送信息的真实性、合法性、无害性、准确性、有效性等全权负责，
            与用户所传播的信息相关的任何法律责任由用户自行承担，与公司无关。如因此给公司或第三方造成损害的，
            用户应当依法予以赔偿。
        </p>
        <p class="content">
            6.4公司提供的服务中可能包括广告，用户同意在使用过程中显示公司和第三方供应商、合作伙伴提供的广告。
            除法律法规明确规定外，用户应自行对依该广告信息进行的交易负责，对用户因依该广告信息进行的交易或
            前述广告商提供的内容而遭受的损失或损害，公司不承担任何责任。
        </p>
        <p class="content">
            6.5除非公司书面许可，用户不得从事下列任一行为:
        </p>
        <p class="content">
            (1)删除软件及其副本上关于著作权的信息;
        </p>
        <p class="content">
            (2)对软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码;
        </p>
        <p class="content">
            (3)对公司拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等;
        </p>
        <p class="content">
            (4)对软件或者软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，
            以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，
            形式包括但不限于使用插件、外挂或非经公司授权的第三方工具/服务接入软件和相关系统;
        </p>
        <p class="content">
            (5)通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，
            或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的;
        </p>
        <p class="content">
            (6)通过非公司开发、授权的第三方软件、插件、外挂、系统，登录或使用公司软件及服务，
            或制作、发布、传播非公司开发、授权的第三方软件、插件、外挂、系统。
        </p>
  

        <p class="contentBlack">7、虚拟货币</p>
        <p class="content">
            7.1您可在“{{ this.name }}”平台购买虚拟货币，即金币。人民币购买金币的比例依您购买渠道的不同而有所不同，
            具体购买比例以您购买金币相关渠道服务页面显示为准。公司有权根据运营情况随时变更上述比例，
            并将在您购买金币相关渠道服务页面显示。
        </p>
        <p class="content">
            7.2您知晓并同意，金币一经购买成功，除法律法规明确规定外，在任何情况下不能兑换为法定货币，且公司不予退款。如因您违反国家法律法规、
            违反本协议或其他与“{{ this.name }}”软件及相关服务相关的协议和规则，公司有权暂时或永久封禁您的账号， 账号封禁后，您账户上的剩余金币将被暂时冻结或全部扣除，
            同时不予返还您购买金币时的现金价值。金币在通过网络互动交流服务或购买虚拟礼物赠予其他用户后，对方将根据适时有效的平台规则获得相应的虚拟权益，
            该权益经比例转化后可以提现，金币一经使用即代表消费完成且不可撤销。
        </p>
        <p class="content">
            7.3您知晓并同意，公司有权基于消费安全等方面的考虑不时设定或修改涉及消费的相关事项，
            包括但不限于消费限额、消费次数等。您了解并确认知晓公司的前述设定或修改可能对您的消费产生一定的不便。
        </p>
        <p class="content">
            7.4公司禁止未成年人使用购买金币服务，请未成年人自动退出，请监护人做好监护责任禁止未成年注册使用充值，
            否则视为监护人操作，不予退款。
        </p>
        <p class="content">
            7.5因您自身原因导致公司无法提供金币购买服务或聊币兑换提现失败或提供金币购买服务时发生任何错误而
            产生的任何损失或责任，由您自行负责，公司不承担责任，包括但不限于:
        </p>
        <p class="content">
            a)因您的“{{ this.name }}”账号丢失、被封禁或冻结;
        </p>
        <p class="content">
            b)因您将密码告知他人导致的财产损失;
        </p>
        <p class="content">
            c)因您绑定的第三方支付机构账户的原因导致的任何损失或责任;
        </p>
        <p class="content">
            d)其他您故意或者重大过失导致的或者违反法律法规导致的财产损失。
        </p>
        <p class="content">
            e)因您违规账户被禁用，账户的的金币将被冻结扣除清零，不得退回。
        </p>


        <p class="contentBlack">8.数据储存</p>
        <p class="content">
            8.1公司不对用户在本服务中相关数据的删除或储存失败负责。
        </p>
        <p class="content">
            8.2在用户正常使用本服务期间，公司可以根据实际情况自行决定用户在本服务中数据的最长储存期限，
            并在服务器上为其分配数据最大存储空间等。用户可根据自己的需要自行备份本服务中的相关数据。
        </p>
        <p class="content">
            8.3如用户停止使用本服务或本服务终止，公司可以从服务器上永久地删除用户的数据。本服务停止、终止后，
            公司没有义务向用户返还任何数据。
        </p>


        <p class="contentBlack">9.风险承担</p>
        <p class="content">
            9.1用户理解并同意，“{{ this.name }}”仅为用户提供信息分享、传送及获取的平台，
            用户必须为自己注册帐号下的一切行为负责，包括用户所传送的任何内容以及由此产生的任何后果。
            用户应对“{{ this.name }}”及本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，
            包括因对内容的正确性、完整性或实用性的依赖而产生的风险。
            公司无法且不会对因用户行为而导致的任何损失或损害承担责任。
        </p>
        <p class="content">
            如果用户发现任何人违反本协议约定或以其他不当的方式使用本服务，请立即向公司举报或投诉，
            举报可联系应用内的在线客服人员，公司将依本协议约定进行处理。
        </p>
        <p class="content">
            9.2用户理解并同意，因业务发展需要，公司保留单方面对本服务的全部或部分服务内容变更、暂停、
            终止或撤销的权利，而无须向您负责或承担任何赔偿责任。
        </p>
        <p class="content">
            9.3用户理解并同意，其在注册“{{ this.name }}”帐号时和后续使用中提交的头像、语音签名及其他信息均是真实、
            准确的，任何不真实、不准确的用户信息所产生的全部法律责任由用户自行承担。
            “{{ this.name }}”仅出于为用户提供初次沟通参考的目的而提供采用AI识别和人工比对技术对用户提交的
            头像进行初步认证，公司对该认证结果的真实性、准确性不作保证。
            用户应对“{{ this.name }}”平台上其他注册用户发布的头像等内容自行加以判断，并承担因使用该内容而给自己、
            他人及社会造成的法律责任，包括但不限于因对内容的真实性、准确性或完整性等的依赖而产生的风险，
            公司在法律允许范围内不承担任何责任。
        </p>
        <p class="content">
            如果用户发现任何人提交、发布虚假头像或信息，或盗用他人头像或资料，冒充、利用他人名义的，
            请立即向公司举报或投诉，举报或投诉可通过“{{ this.name }}”APP内举报功能或APP内的在线客服，
            公司将依本协议约定进行处理。
        </p>


        <p class="contentBlack">10.知识产权声明</p>
        <p class="content">
            10.1公司在“{{ this.name }}”软件及相关服务中提供的内容(包括但不限于软件、技术、程序、网页、文字、图片、
            图像、音频、视频、图表、版面设计、电子文档等)的知识产权属于公司所有。公司提供本服务时所依托的软件的著作权、
            专利权及其他知识产权均归公司所有。未经公司许可，任何人不得擅自使用。
        </p>
        <p class="content">
            10.2您理解并同意，在使用“{{ this.name }}”软件及相关服务时发布上传的文字、图片、视频、
            音频等均由您原创或已获合法授权(含转授权)。您通过“{{ this.name }}”上传、
            发布的任何内容的知识产权归属于您或原始著作权人所有。
        </p>
        <p class="content">
            10.3您知悉、理解并同意就您通过“{{ this.name }}”发布上传的内容(包括但不限文字，图片，视频，音频，
            视频及/或音频中包括的音乐作品、声音、对话等)，授予公司及其关联公司、控制公司、
            继承公司在全球范围内的免费、非独家、可再许可(通过多层次)的使用权利
        </p>
        <p class="content">
            (包括但不限于复制权、翻译权、汇编权、信息网络传播权、改编权、制作衍生品等)，
            使用范围包括但不限于当前或其他网站、应用程序、产品或终端设备等。您在此确认并同意，
            上述权利的授予包括在“{{ this.name }}”、公司和或公司品牌有关的任何推广、广告、
            营销和或宣传中使用和以其他方式开发内容(全部或部分)的权利和许可。为避免疑惑，
            您同意，上述权利的授予包括使用、复制和展示您拥有或被许可使用并植入内容中的个人形象、
            肖像、姓名、商标、服务标志、品牌、名称、标识和公司标记(如有)以及任何其他品牌、营销或推广资产的权利和许可。
        </p>


        <p class="contentBlack">11.法律责任</p>
        <p class="content">
            11.1如果公司发现或收到他人举报或投诉用户违反本协议约定的，公司有权不经通知随时对相关内容，
            包括但不限于用户资料、聊天记录进行审查、删除，并视情节轻重对违规帐号处以包括但不限于警告、
            帐号封禁、设备封禁、功能封禁的处罚，且通知用户处理结果。
        </p>
        <p class="content">
            11.2您有权对本服务其他用户的违法、违规、或其他您认为侵犯您个人权益的行为向公司进行举报，
            您承诺前述举报行为均真实可信，公司在接到举报后将积极予以会应。但请您知悉，
            如您的举报行为造成被举报人、公司、或任何其他方合法权益受损，您应当承担举报或投诉所产生的全部法律责任。
            如公司先行承担责任的，公司有权对您进行追偿，您有义务在收到公司的追偿通知时全额赔偿公司的损失。
        </p>
        <p class="content">
            11.3因违反本协议被封禁后，您可向客服提交申诉，公司将对申诉进行审查，并合理判断和决定是否变更处罚措施。
        </p>
        <p class="content">
            11.4用户理解并同意，公司有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，
            对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，
            用户应承担由此而产生的一切法律责任。
        </p>
        <p class="content">
            11.5用户理解并同意，因用户违反本协议约定，导致或产生的任何第三方主张的任何索赔、要求或损失，
            包括合理的律师费，用户应当赔偿公司与合作公司、关联公司，并使之免受损害。
        </p>
        <p class="content">
            11.6用户在遵守本协议的前提下，为平台进行推广将获得额外奖励收益。如用户违反本协议内容，
            平台有权扣除用户在本平台内部分或所有收益，并封停账号。
        </p>


        <p class="contentBlack">12、不可抗力及其他免责事由</p>
        <p class="content">
            12.1用户理解并确认，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。
            不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，
            包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为等。
            出现上述情况时，公司将努力在第一时间与相关单位配合，及时进行修复，
            但是由此给用户或第三方造成的损失，公司及合作单位在法律允许的范围内免责。
        </p>
        <p class="content">
            12.2本服务同大多数互联网服务一样，受包括但不限于用户原因、网络服务质量、
            社会环境等因素的差异影响，可能受到各种安全问题的侵扰，如他人利用用户的资料，
            造成现实生活中的骚扰；用户下载安装的其它软件或访问的其他网站中含有“特洛伊木马”等病毒，
            威胁到用户的计算机信息和数据的安全，继而影响本服务的正常使用等等。
            用户应加强信息安全及使用者资料的保护意识，要注意加强密码保护，以免遭致损失和骚扰。
        </p>
        <p class="content">
            12.3用户理解并确认，本服务存在因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、
            用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险，
            因此导致的用户或第三方任何损失，公司不承担任何责任。
        </p>
        <p class="content">
            12.4用户理解并确认，在使用本服务过程中存在来自任何他人的包括误导性的、欺骗性的、威胁性的、
            诽谤性的、令人反感的或非法的信息，或侵犯他人权利的匿名或冒名的信息，以及伴随该等信息的行为，
            因此导致的用户或第三方的任何损失，公司不承担任何责任。
        </p>
        <p class="content">
            12.5用户理解并确认，尽管公司会竭力确保本服务一天24小时都能正常使用，
            但公司不保证它不会中断或不发生任何错误。如系统发生故障导致服务的访问暂时中止，
            公司可能无法事先通知您，在此情况下对您造成的损失(如有)您同意免除公司的赔偿责任。
        </p>
        <p class="content">
            12.6用户理解并确认，公司需要定期或不定期地对“{{ this.name }}”平台或相关的设备进行检修或者维护，
            如因此类情况而造成服务在合理时间内的中断，公司无需为此承担任何责任，但公司应事先进行通告。
        </p>
        <p class="content">
            12.7公司依据法律法规、本协议约定获得处理违法违规或违约内容的权利，该权利不构成公司的义务或承诺，
            公司不能保证及时发现违法违规或违约行为或进行相应处理。
        </p>
        <p class="content">
            12.8用户理解并确认，对于公司向用户提供的下列产品或者服务的质量缺陷及其引发的任何损失，
            公司无需承担任何责任:
        </p>
        <p class="content">
            (1)公司向用户免费提供的服务;
        </p>
        <p class="content">
            (2)公司向用户赠送的任何产品或者服务。
        </p>
        <p class="content">
            12.9在任何情况下，公司均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，
            包括因用户使用“{{ this.name }}”或本服务而遭受的利润损失承担责任(即使公司已被告知该等损失的可能性亦然)。
            尽管本协议中可能含有相悖的规定，公司对用户承担的全部责任，无论因何原因或何种行为方式，
            始终不超过用户因使用公司提供的服务而支付给公司的费用(如有)。
        </p>


        <p class="contentBlack">13、服务的变更、中断、终止</p>
        <p class="content">
            13.1鉴于网络服务的特殊性，用户同意公司有权随时变更、中断或终止部分或全部的服务(包括收费服务)。
            公司变更、中断或终止的服务，公司应当在变更、中断或终止之前通知用户，
            并应向受影响的用户提供等值的替代性的服务；如用户不愿意接受替代性的服务，
            如果该用户已经向公司支付了金币，
            公司应当按照该用户实际使用服务的情况扣除相应金币之后将剩余的金币退还用户的金币账户中。
        </p>
        <p class="content">
            13.2如发生下列任何一种情形，公司有权变更、中断或终止向用户提供的免费服务或收费服务，
            而无需对用户或任何第三方承担任何责任:
        </p>
        <p class="content">
            (1)根据法律规定用户应提交真实信息，而用户提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明;
        </p>
        <p class="content">
            (2)用户违反相关法律法规或本协议的约定;
        </p>
        <p class="content">
            (3)按照法律规定或有权机关的要求;
        </p>
        <p class="content">
            (4)出于安全的原因或其他必要的情形。
        </p>

        <p class="contentBlack">14.其他</p>
        <p class="content">
            14.1公司郑重提醒用户注意本协议中免除公司责任和限制用户权利的条款，请用户仔细阅读，自主考虑风险。
        </p>
        <p class="content">
            14.2本协议的效力、解释及纠纷的解决，适用于中华人民共和国法律。
            若因本协议引起的或与本协议有关的纠纷或争议，公司将与用户友好协商解决。
            协商不成的，用户同意将纠纷或争议提交中国国际经济贸易仲裁委员会，
            根据其现行有效的仲裁规则进行仲裁。仲裁裁决是终局的，对双方都有约束力。仲裁费用由败诉一方承担。
        </p>
        <p class="content">
            14.3本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方具有约束力。
        </p>
        <p class="content">
            14.4由于互联网高速发展，您与公司签署的本协议列明的条款可能并不能完整罗列并
            覆盖您与“{{ this.name }}”所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。
            因此，“{{ this.name }}”隐私政策、“{{ this.name }}”充值协议、“{{ this.name }}”VIP服务协议等均为本协议的补充协议，
            与本协议不可分割且具有同等法律效力。如您使用{{ this.name }}平台服务，视为您同意上述补充协议。
        </p>
        <p class="content">
            14.5本协议中的标题仅供方便而设，不作为解释本条款的依据。“{{ this.name }}”对本协议享有最终解释权。
        </p>


        <p class="contentBlack"></p>
        <p class="content"></p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            id: '',
            gender: '',
            token: '',
            edition: '',

            name: '音缘',
            company: '长沙鼎韵网络科技有限公司'
        }
    },

    created() {
        document.title = '用户协议';
        this.checkURLParams();
    },

    methods: {
        checkURLParams() {
            // do some
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    background-color: #FFF;
}

.content {
    font-size: 12px;
    color: #666;
}
.contentBlack {
    font-size: 14px;
    color: black;
    font-weight: 700;
}
</style>